import { useCallback, useMemo, useState } from 'react';
import { notification } from 'tea-component';
import { getExecutiveSummaryData } from '@sg/services/index';
import {
  BUSINESS_OVERALL_GROSS_REVENUE_CARD,
  BUSINESS_OVERALL_PROFIT_CARD,
} from '../../config';

/**
 * Owns the Executive Summary API state and the two MetricCard configs
 * (revenue + profit) derived from it.
 */
export function useExeSummaryData() {
  // Raw response from getExecutiveSummaryData; null until first fetch resolves
  const [apiData, setApiData] = useState<any>(null);

  const fetchExecutiveSummaryData = useCallback(async () => {
    try {
      const response = await getExecutiveSummaryData({});
      setApiData(response.data);
    } catch (err) {
      notification.error({
        description: `Failed to fetch executive summary data: ${err}`,
      });
      setApiData(null);
    }
  }, []);

  // Create configs with API data
  const revenueConfig = useMemo(() => {
    return BUSINESS_OVERALL_GROSS_REVENUE_CARD(apiData);
  }, [apiData]);

  const profitConfig = useMemo(() => {
    return BUSINESS_OVERALL_PROFIT_CARD(apiData);
  }, [apiData]);

  return {
    revenueConfig,
    profitConfig,
    fetchExecutiveSummaryData,
  };
}
